import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const getLeyendaFirmaList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetGrillaLeyendasFirmas`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const addLeyendaFirma = (data, accessToken) => {

    const url = `${apiUrl}formularios/FrmInsertLeyendaFirmasSoc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}

const FrmUpdateLeyendaFirmasSoc = (data, accessToken) => {

    const url = `${apiUrl}formularios/FrmUpdateLeyendaFirmasSoc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}



const FrmDelLeyendafirmasSoc = (data, accessToken) => {

    const url = `${apiUrl}formularios/FrmDelLeyendafirmasSoc` 

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { 
            return;
        })
        .catch(
            error => { 
               
            }); 

}

/* 
const getLeyendaPosicionList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetLeyendasPosicion`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};
 */

export { getLeyendaFirmaList, addLeyendaFirma, FrmDelLeyendafirmasSoc, FrmUpdateLeyendaFirmasSoc }